import React, { useState, useMemo, useEffect, useRef } from 'react'
import {useQuery, useClient} from 'jsonapi-react'
import LeadError from '../LeadError'
import Checkbox from 'app/theme/forms/Checkbox'
import { Spinner } from 'app/theme/Spinner'
import { X } from 'react-feather'

export default function LeadFoodTypes(props) {
  const { setData, errors, setErrors } = props
  const [selectedFoodTypes, setSelectedFoodTypes] = useState(new Set())
  const [loading, setLoading] = useState(false)
  const client = useClient()

  const foodTypeQuery = {
    data: [
      {
        code: 'savory',
        name: 'Savory',
      },
      {
        code: 'drinks',
        name: 'Drinks',
      },
      {
        code: 'dessert',
        name: 'Dessert',
      },
    ]
  }

  useEffect(() => {
    setData(prev => ({
      ...prev,
      food_types: [...selectedFoodTypes],
    }))
  }, [selectedFoodTypes])

  
  function SubHeader() {
    return (
      <p className='font-light text-lg p-4 pt-0'>
        Choose the types of food trucks you’re interested in. Some offer full menus with all options, while others 
        specialize in desserts, drinks, or other treats (like ice cream trucks or coffee carts).
      </p>
    )
  }

  return (
    <div>
      {loading ? (
        <div className="">
          <Spinner className="text-blue w-10 h-10 mx-auto my-5"/>
        </div>
      ) : (
        <>
          <SubHeader />
          <div className="flex flex-wrap justify-between font-light max-w-5xl">
            {foodTypeQuery.data?.map((type, index) => (
              <div
                key={type.code}
                className='px-4 py-3'
              >
                <Checkbox
                  label={type.name}
                  data-test-id='food_types'
                  checked={selectedFoodTypes.has(type.code)}
                  onChange={checked => {
                    setErrors(false)

                    if (checked) {
                      setSelectedFoodTypes(prev =>  {
                        return new Set(prev.add(type.code))
                      })
                    } else {
                      setSelectedFoodTypes(prev => {
                        prev.delete(type.code)
                        return new Set(prev)
                      })
                    }
                  }}
                />
              </div>
            ))}
          </div>
          {errors?.food_types && (
            <div className="px-8 py-3 font-bold text-center">
              <LeadError
                message={errors.food_types}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}
